import React from 'react'
import styled from 'styled-components'

type BalanceTypes = {
    className?: string
    mainText?: string,
    subText: string
}

function Balance(props: BalanceTypes) {

    return (
        <StyledBalance className={props.className}>
            <img src={'/dashboard/analytic/balance.png'} width={75} height={75} alt='balance' />
            <div className='content'>
                <div className='mainText'>{props.mainText}</div>
                <div className='subtext'>{props.subText}</div>
            </div>
        </StyledBalance>
    )
}


const StyledBalance = styled.div`
  background: white;
  border-radius: 15px;
  padding: 20px;
  box-sizing: border-box;
  filter: drop-shadow(0px 3px 6px rgba(39, 45, 59, 0.2));
  height: 115px;
  display: flex;
  width: 100%;
  font-family: "Open Sans";

  .content {
    margin-left: 32px;
    display: flex;
    flex-direction: column;

    .mainText {
      font-size: 26px;
      font-weight: bold;
    }

    .subText {
      font-size: 18px;
    }
  }

`

export default Balance